import React from 'react';
import { TruckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const zones = [{
  zone: 'Island (Lekki, VI, Ikoyi)',
  fee: 'from ₦X'
}, {
  zone: 'Mainland (Yaba, Ikeja, Surulere)',
  fee: 'from ₦X'
}, {
  zone: 'Ikorodu axis',
  fee: 'from ₦X'
}];
export function DeliveryAreas() {
  return <section id="delivery-areas" className="w-full bg-white py-14 sm:py-20" data-id="element-17" data-mp="8rfhbaefqy7p">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-18" data-mp="3h77idmwdgvr3">
        <Reveal className="text-center md:text-left" data-id="element-19" data-mp="3h7r1v81o7s78">
          <h2 className="font-display text-3xl uppercase tracking-tight text-purple sm:text-4xl" data-id="element-20" data-mp="3c8xkh4j9jh1s">Delivery Areas</h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-8" data-id="element-21" data-mp="3q9qk23of92br">
          <ul className="divide-y divide-lavender overflow-hidden rounded-card border border-lavender shadow-soft" data-id="element-22" data-mp="3l92lmwxv5j7i">
            {zones.map(item => <li key={item.zone} className="flex items-center justify-between gap-4 bg-white px-5 py-4 transition duration-300 hover:bg-lavender-light sm:px-6" data-id="element-23" data-mp="15gwvkdrhhsl0">
                <span className="flex items-center gap-3 text-sm font-medium text-ink sm:text-base" data-id="element-24" data-mp="7xhrjwrwzg4f">
                  <TruckIcon className="h-5 w-5 shrink-0 text-purple" aria-hidden="true" data-id="element-25" data-mp="byta5icdf134" />
                  {item.zone}
                </span>
                <span className="shrink-0 rounded-full bg-lavender px-3 py-1 text-sm font-bold text-purple" data-id="element-26" data-mp="gzhboxy870bl">
                  {item.fee}
                </span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.15} data-id="element-27" data-mp="3kghfhml3gotj">
          <p className="mt-4 text-center text-sm text-ink/60 md:text-left" data-id="element-28" data-mp="3kd1zmhjljbr2">
            Delivery anywhere in Lagos. Fee depends on your area.
          </p>
        </Reveal>
      </div>
    </section>;
}